var map = {
	"./de.json": 751,
	"./en.json": 752,
	"./es.json": 753,
	"./fr.json": 754,
	"./it.json": 755,
	"./ja.json": 756,
	"./ko.json": 757,
	"./pt.json": 758,
	"./ru.json": 759,
	"./zh.json": 760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 750;